import React, {useState} from 'react'
import Tooltip from "@material-ui/core/Tooltip";

import '../../assets/css/translatedLangs.css'
import LangFormatter from "../tables/langFormatter";

const TranslatedItem = props => {
    const {code, name, translated} = props.langTranslated || {}

    return <Tooltip title={name + (!translated ? ' - No traducido' : '')} placement="bottom" >
        <div className={`translated-lang ${translated && 'translated'}`} id={`Tooltip-${code}`}>
            <LangFormatter langCode={code} nativeName={name} translated={translated} />
        </div>
    </Tooltip>
}

const TranslatedLangs = props => {
    const translatableLangs= props?.translatableLangs || []

    if(translatableLangs.length <=0)
        return

    return <div className={'translated-langs-container'}>
        {
            translatableLangs.map((langTranslated, i) => {
                if(langTranslated?.lang?.code?.toLowerCase() === 'es' || langTranslated?.lang?.code?.toLowerCase() === 'en')
                    return

                return (
                        <TranslatedItem
                            key={i}
                            langTranslated={langTranslated}
                        />
                    )
            })
        }
    </div>
}
export default TranslatedLangs


export const CountryFlags = ({langs = []}) => <div className={'country-flags-container d-flex'}>
    <div className={'container-title'}>Idiomas activos:</div>
    <div className={'translated-langs-container'}>
        {
            langs.map(({code, nativeName}, i) => <Tooltip title={nativeName} placement="bottom" key={i}>
                <div className={'translated-lang'}>
                    <LangFormatter
                        langCode={code}
                        nativeName={code}
                    />
                </div>
            </Tooltip>)
        }
    </div>
</div>
